import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/store';

export interface BusyTask {
  id: string;
  description: string;
}

interface BundleBusyTasksState {
  tasks: BusyTask[];
}

const initialState: BundleBusyTasksState = {
  tasks: [],
};

const bundleBusyTasksSlice = createSlice({
  name: 'bundleBusyTasks',
  initialState,
  reducers: {
    pushBusyTask: (state, action: PayloadAction<BusyTask>) => {
      // Replace any existing task with the same id so re-pushes reset the description.
      state.tasks = state.tasks.filter((task) => task.id !== action.payload.id);
      state.tasks.push(action.payload);
    },
    popBusyTask: (state, action: PayloadAction<string>) => {
      state.tasks = state.tasks.filter((task) => task.id !== action.payload);
    },
    clearBusyTasks: (state) => {
      state.tasks = [];
    },
  },
});

export const { pushBusyTask, popBusyTask, clearBusyTasks } = bundleBusyTasksSlice.actions;

export const selectBusyTasks = (state: RootState) => state.bundleBusyTasks.tasks;

export const selectFirstBusyTask = (state: RootState) => state.bundleBusyTasks.tasks[0] ?? null;

export const bundleBusyTasksReducer = bundleBusyTasksSlice.reducer;
